<template>
  <Box>
    <template #handle>
      <Btn v-if="hasPermi('system:clientupgraderange:upgradeListSettings')" @click="addItem('加入名单')">加入名单</Btn>
      <Btn v-if="hasPermi('system:clientupgraderange:upgradeListSettings')" @click="addItem('退出名单')">退出名单</Btn>
      <Btn v-if="hasPermi('system:clientupgraderange:cancelAll')" @click="addItem('全部取消')">全部取消</Btn>
      <Btn @click="$router.go(-1)">返回</Btn>
    </template>
    <template #content>
      <div class="table_main">
        <div class="query">
          <div class="left">
            <el-form ref="query_form" :model="queryParams" label-width="80px">
              <el-row>
                <el-col :span="6">
                  <el-form-item label="所属企业" prop="companyname">
                    <el-input size="small" v-model.trim="queryParams.companyname"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="省市区" prop="qy">
                    <Region :qy="queryParams.qy" @change="change" />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="时间范围" prop="upgradeTime">
                      <el-date-picker v-model="queryParams.upgradeTime" type="datetimerange" range-separator="至"
                          start-placeholder="开始日期" end-placeholder="结束日期"
                          format="yyyy-MM-dd HH时" value-format="yyyy-MM-dd HH" size="small">
                      </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="名单类型" prop="mdtype">
                    <el-select size="small" v-model.trim="queryParams.mdtype" clearable>
                      <el-option v-for="item in mdtypes" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <div class="right">
            <Btn @click="query" round>
              <span class="btn_box">
                <i class="iconfont icon-sousuo"></i>
                <span>搜索</span>
              </span>
            </Btn>
            <Btn @click="initQuery" round>
              <span class="btn_box">
                <i class="iconfont icon-chongzhi"></i>
                <span>重置</span>
              </span>
            </Btn>
          </div>
        </div>
        <div class="content">
          <Table :datas="tableData" :heads="tableHead" :selection="true" @change="changeTableSelected" :loading="loading">
            <template #handle="data">
              <div class="table_cell">
                <span v-if="data.head.handle == 'index'">{{
                    (pageData.page - 1) * pageData.pageSize + data.index
                }}</span>
                <span v-if="data.head.handle == 'flag'">
                  {{ tempMdtype != 1 ? (data.data.flag ? "已录入" : "") : "" }}
                </span>
                <span v-if="data.head.handle == 'sbstate'" :class="['pre']">
                  <span class="_pre" :style="{
                    background: (
                      sbstate.find((a) => a.value == data.data.sbstate) || {}
                    ).color,
                  }"></span>
                  <span>{{ data.data.sbstate }}</span>
                </span>
              </div>
            </template>
          </Table>
          <el-pagination class="page" background layout="total, sizes, prev, pager, next" :total="pageData.total" :page-sizes = "[10, 20, 50, 100]"
            :current-page.sync="pageData.page" :page-size.sync="pageData.pageSize" @size-change="query" @current-change="getList">
          </el-pagination>
        </div>
      </div>
      <el-dialog title="设置升级时间" :visible.sync="timeDialog" width="30%" :before-close="timeClose">
        <el-form label-width="80px">
            <el-row>
                <el-form-item label="升级时间">
                    <el-date-picker v-model="upgradeTime" type="datetimerange" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期"
                        format="yyyy-MM-dd HH时" value-format="yyyy-MM-dd HH" size="small">
                    </el-date-picker>
                </el-form-item>
            </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="timeClose">取 消</el-button>
          <el-button size="small" type="primary" @click="timeCommit">确 定</el-button>
        </span>
      </el-dialog>
    </template>
  </Box>
</template>

<script>
import { mdtypes, sbstate } from "@/utils/status";
import {
  releaseScopeList,
  cancelAll,
  upgradeListSettings,
} from "@/api/CollectionSystemSetUpManagement";
import Upload from "@/components/upload";
import Region from "@/components/region";
import permMixin from "@/mixins/perm";
import moment from "moment";
export default {
  mixins: [permMixin],
  components: { Region, Upload },
  data() {
    return {
      mdtypes,
      sbstate,
      loading: false,
      pageData: {
        total: 0,
        page: 1,
        pageSize: 10,
      },
      tableData: [],
      queryParams: {
        companyname: "",
        qy: "",
        mdtype: "",
        upgradeTime: []
      },
      tempMdtype: null,
      tableHead: [
        {
          prop: "xh",
          label: "序号",
          handle: "index",
          width: 50,
          textAlign: "center",
        },
        {
          prop: "companycode",
          label: "企业代码",
          textAlign: "center",
        },
        {
          prop: "companyname",
          label: "企业名称",
          minWidth: 200,
        },
        {
          prop: "sccode",
          label: "生产线编号",
          textAlign: "center",
        },
        {
          prop: "nnc",
          label: "设备编号",
        },
        {
          prop: "sbstate",
          label: "设备状态",
          handle: "sbstate",
          textAlign: "center",
        },
        // {
        //   prop: "province",
        //   label: "省",
        // },
        // {
        //   prop: "city",
        //   label: "市",
        // },
        // {
        //   prop: "area",
        //   label: "区",
        // },
        {
          prop: "upgradeBegin",
          label: "升级开始时间",
          minWidth: 100,
        },
        {
          prop: "upgradeEnd",
          label: "升级结束时间",
          minWidth: 100,
        },
        {
          prop: "flag",
          label: "黑白名单",
          handle: "flag",
          textAlign: "center",
        },
      ],
      addForm: {
        versionTag: "",
        version: "",
        context: "",
        releaseScope: "",
      },
      initAddForm: {},
      tableSelected: [],
      upgradeTime: [],
      timeDialog: false,
      operationParam: {
          versionid: this.$route.query.id,
          flag: "",
          sbids: [],
          upgradeTime: []
      }
    };
  },
  methods: {
    change(val) {
      this.queryParams.qy = val;
    },
    toPath(id) {
      this.$router.push({
        path: `/ReleaseNameListSetUp`,
        query: {
          id,
        },
      });
    },
    changeTableSelected(arr = []) {
      this.tableSelected = arr;
    },
    addItem(title) {
      switch (title) {
        case "全部取消":
          cancelAll(this.operationParam).then((res) => {
            this.$message({
              message: res.msg,
              type: "success",
            })
            this.getList();
          });
          break;
        case "加入名单":
          if (!this.tableSelected.length) {
            this.$message.info("请勾选条目");
            return;
          }
          this.operationParam.flag = 1;
          this.operationParam.sbids = this.tableSelected.map((item) => item.sbid)
          this.upgradeTime = []
          this.timeDialog = true
          break;
        case "退出名单":
          if (!this.tableSelected.length) {
            this.$message.info("请勾选条目");
            return;
          }
          this.operationParam.flag = 2;
          this.operationParam.sbids = this.tableSelected.map((item) => item.sbid)
          upgradeListSettings(this.operationParam).then((res) => {
            this.$message({
              message: res.msg,
              type: "success",
            })
            this.getList();
          });
          break;
      }
    },
    initQuery() {
      this.pageData.page = 1;
      this.tempMdtype = "";
      this.$refs.query_form.resetFields();
      this.queryParams.qy = "";
    },
    timeClose() {
        this.upgradeTime = []
        this.timeDialog = false
    },
    timeCommit() {
        this.operationParam.upgradeTime = this.upgradeTime
        upgradeListSettings(this.operationParam).then((res) => {
          this.$message({
            message: res.msg,
            type: "success",
          })
          this.getList()
          this.timeClose()
        });
    },
    query() {
      this.pageData.page = 1;
      this.tempMdtype = this.queryParams.mdtype;
      this.getList();
    },
    getList() {
      if (!this.$route.query.id) return;
      this.loading = true
      const params = {
        ...this.queryParams,
        versionid: this.$route.query.id,
        currentPage: this.pageData.page,
        pageSize: this.pageData.pageSize
      };
      releaseScopeList(params)
        .then((res) => {
          this.pageData.total = res.data.count;
          this.tableData = res.data?.list || [];
          this.tableData.forEach((item) => {
            item.upgradeBegin = item.upgradeBegin ? moment(item.upgradeBegin).format("YYYY-MM-DD HH时") : ''
            item.upgradeEnd = item.upgradeEnd ? moment(item.upgradeEnd).format("YYYY-MM-DD HH时") : ''
          })
          this.loading = false
        })
        .catch((err) => {
          this.pageData.total = 0;
          this.tableData = [];
          this.loading = false
        });
    },
  },
  created() {
    this.getList();
  },
};
</script>
